export const routes = {
  root: "/",
  login: "/login",
  dashboard: "/dashboard/:companyId",
  resetPassword: "/reset-password",
  confirmAccount: "/confirm-account",
  admin: "/admin",
  google: "/google",
};
